import * as notifications from "utils/notifications";

export type ValidationErrors = Record<string, string[]>;

export async function notifyAboutFailureOrReloadPage(response: Response): Promise<void> {
  if (response.ok) {
    await response.text();
    window.location.reload();
  } else {
    await notifyAboutFailure(response);
  }
}

export async function notifyAboutFailure(response: Response): Promise<void> {
  if (!response.ok) {
    notifications.alert(await parseError(response));
  }
}

export async function notifyAboutFailureOrSuccess(response: Response): Promise<void> {
  if (response.ok) {
    notifications.success(await parseResponse(response, "success"));
  } else {
    notifications.alert(await parseError(response));
  }
}

export function parseError(response: Response): Promise<string> {
  return parseResponse(response, "error");
}

async function parseResponse(response: Response, field: string): Promise<string> {
  try {
    return (await response.clone().json())[field];
  } catch (e) {
    return await response.clone().text();
  }
}
